import React from 'react';

export const DETAIL_TABS = [
  { key: 'overview', label: 'Overview' },
  { key: 'audience', label: 'Audience' },
  { key: 'completion', label: 'Completion' },
  { key: 'analytics', label: 'Analytics' },
  { key: 'answers', label: 'Student answers' },
];

const SurveyDetailTabs = ({ activeTab, onTabChange }) => {
  return (
    <div className="survey-detail-tabs">
      {DETAIL_TABS.map((tab) => (
        <button
          key={tab.key}
          type="button"
          className={`survey-detail-tab ${activeTab === tab.key ? 'active' : ''}`}
          onClick={() => onTabChange(tab.key)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default SurveyDetailTabs;
